
import { MediaOwnerPricingConstants } from './types';

// Alan pricing constants
export const ALAN_COST_PER_DEVICE_PER_DAY = 95;
export const ALAN_DISCOUNT_SCREENS_THRESHOLD = 60;
export const ALAN_BASE_DISCOUNT_RATE = 0.10;
export const ALAN_MAX_DISCOUNT_RATE = 0.30;

export const alanPricingConstants: MediaOwnerPricingConstants = {
  costPerDevicePerDay: ALAN_COST_PER_DEVICE_PER_DAY,
  discountScreensThreshold: ALAN_DISCOUNT_SCREENS_THRESHOLD,
  baseDiscountRate: ALAN_BASE_DISCOUNT_RATE,
  maxDiscountRate: ALAN_MAX_DISCOUNT_RATE
};
